// src/components/Admin/StudentHomeCmp/studentTask/sceneMeta.js
import { VirtualScenes } from "../../../../api/virtualscene";

const vsApi = new VirtualScenes();

/**
 * Resuelve metadatos de escena priorizando la ruta enriquecida:
 *  - GET /virtualscene/:id  (bannertop.url ya populado)
 * Fallback:
 *  - GET /virtualscene/:id/module_01
 */
export async function resolveSceneMeta(accessToken, next) {
  // Si backend ya trae meta en /next, úsalo directamente
  if (next?.sceneTitle || next?.sceneBanner || next?.sceneEnterUrl) {
    return {
      title: next.sceneTitle || "Escena",
      bannerUrl: next.sceneBanner || "",
      enterUrl: next.sceneEnterUrl || "",
      descriptionHtml: next.sceneDescriptionHtml || "",
    };
  }

  if (!next?.scene) {
    return {
      title: "Escena",
      bannerUrl: "",
      enterUrl: "",
      descriptionHtml: "",
    };
  }

  // 1) Enriquecido completo
  try {
    const scene = await vsApi.getVirtualSceneById(accessToken, next.scene);
    const m1 = scene?.module_01 || {};

    const title = m1.ModOneTitle || "Escena";
    const bannerUrl =
      (typeof m1?.bannertop === "object" && m1?.bannertop?.url) || "";
    const enterUrl =
      m1.ModOneUrlsala || m1.urlsala || m1.urlSala || m1.sceneactive || "";
    const descriptionHtml = m1.ModOneDescription || m1.description || "";

    return { title, bannerUrl, enterUrl, descriptionHtml };
  } catch (_) {
    // sigue al fallback
  }

  // 2) Fallback: módulo 01 simple (moduleData)
  try {
    const resp = await vsApi.getVirtualScenesModeule(
      next.scene,
      accessToken,
      "module_01",
    );
    const m = resp?.moduleData || {};
    const title = m.ModOneTitle || "Escena";
    const bannerUrl = (m?.bannertop && m?.bannertop.url) || ""; // por si viniera expandido
    const enterUrl = m.ModOneUrlsala || m.urlsala || "";
    const descriptionHtml = m.ModOneDescription || "";
    return { title, bannerUrl, enterUrl, descriptionHtml };
  } catch (_) {
    return {
      title: "Escena",
      bannerUrl: "",
      enterUrl: "",
      descriptionHtml: "",
    };
  }
}
